<div class="container">
  <span>{{ 'shared.features.globalSearch.view' | translate }} </span>
  <tsh-report-filter-selector
    title=""
    [options]="options"
    [field]="field">
  </tsh-report-filter-selector>
</div>
